export var NativeNavigationChannels;
(function (NativeNavigationChannels) {
    NativeNavigationChannels["beforeNavigation"] = "sb_nativeRedirectBeforeNavigation";
    NativeNavigationChannels["initHomePanel"] = "sb_nativeRedirectHomePanel";
    NativeNavigationChannels["openGame"] = "sb_nativeOpenGame";
})(NativeNavigationChannels || (NativeNavigationChannels = {}));
//# sourceMappingURL=NativeNavigationChannels.js.map